import { Node_Type } from "./../../ricos-types/index.js";
import Caption from "../../_shared/figure/viewer-caption.js";
import Video from "./viewer-video.js";
const nodeViewRenderers = {
  [Node_Type.VIDEO]: Video,
  [Node_Type.CAPTION]: Caption
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
